import { browserHistory } from 'react-router';
import * as types from '../constants/actionTypes';
import { resourceApi } from '../utils/fetchUtil';
import { showGlobalSpinner, hideGlobalSpinner} from './environmentActions';
import { decrementBadge } from './cordovaActions';

function receiveMessages(messages) {
  return {
    type: types.RECIEVE_MESSAGES,
    messages: messages
  }
}

function receiveNewMessage(message) {
  return {
    type: types.RECEIVE_MESSAGE,
    message: message
  }
}



function setDimensions(dimensions){
  return {
    type: types.SET_DIMENSIONS,
    dimensions: dimensions
  }
}


function showMessage(message) {
  return {
    type: types.SHOW_MESSAGE,
    message: message
  }
}

export function fixMessage(message) {
  return {
    type: types.FIX_MESSAGE,
    message: message
  }
}

export function deleteMessageReply(reply) {
  return {
    type: types.DELETE_MESSAGE_REPLY,
    replyId: reply.SystemMessageReplyID
  }
}

export function showMessages() {
  return {
    type: types.SHOW_MESSAGES
  }
}

export function showMessagesAction() {
  return (dispatch, getState) => {     
    dispatch(showMessages());
  }
}

function deleteMessageFromRedux(messageId) {
  return {
    type: types.REMOVE_MESSAGE,
    messageId: messageId
  }
}

function clearTheDot(id) {
  return {
    type: types.CLEAR_THE_DOT,
    id: id
  }
}

export function setMinHeight(height){
  return {
    type: types.SET_MIN_HEIGHT,
    height: height
  }
}


export function updateGlobalNewMessageCount(){
  return {
    type: types.UPDATE_GLOBAL_NEW_MESSAGE_COUNT
  }
}

export function createNewMessage() {
  return {
    type: types.NEW_MESSAGE
  }
}

export function addMessageReply(reply) {
  return {
    type: types.ADD_MESSAGE_REPLY,
    reply: reply
  }
}

export function indicateNewMessage(message) {
  return {
    type: types.INDICATE_NEW_MESSAGE,
    message: message
  }
}

export function appendNewMessageToListView(message) {
  return {
    type: types.APPEND_NEW_MESSAGE,
    message: message
  }
}

function receiveMessageReplies(replies) {
  return {
    type: types.RECEIVE_MESSAGE_REPLIES,
    replies: replies
  }
}

export function selectATopic(id, text) {
  return {
    type: types.SELECT_A_TOPIC,
    id: id, 
    text: text
  }
} 

export function loadMessages(){

  return (dispatch) => {
        
      let config = {
        method: 'get',
        url: `member/messages`
      };

      resourceApi(config, dispatch)
      .then(function (response) {
          dispatch(receiveMessages(response.data));
      })
      .catch(function (error) {
          console.log(error);
      });
    };
}

export function sendMessage(message, clientUserDocumentId){
  
  return (dispatch, getState) => {
  
    var _m = getState().thisApp.messaging.message;

    //_m.Message = message;
    var m = Object.assign({}, _m);
    m.Message = message;

    if(clientUserDocumentId) {
      m.ClientUserDocumentID = clientUserDocumentId;
    }

    m.replies = null;

    let config = {
        method: 'post',
        url: `member/message/send`,
        data: m
    };
    
    var newMessage = (_m.SystemMessageID === 0); 

    resourceApi(config) 
    .then(function (response) {
        // console.log(response);

        if(newMessage) {
          dispatch(receiveNewMessage(response.data.message));
        }

        // ADD REPLY TO ACTIVE MESSAGE
        dispatch(addMessageReply(response.data.reply));

        dispatch(appendNewMessageToListView(response.data.reply)); 


        var element = document.getElementById("endOfChat");
        if(element) {
          //uses smoothscrolling-polyfill plugin, maths out to just above the chat input once user sends message and keyboard collapses.
          if(window.device && window.device.platform.toLowerCase() === 'ios'){
            // window.scrollTo({behavior:"smooth", top:(element.offsetTop - window.innerHeight)});
            window.scrollTo(0,(element.offsetTop - window.innerHeight));
          }
          else {       
            element.scrollIntoView({behavior:"smooth", block:"end"});
          }
        }


        // let e = document.getElementById("endOfChat");
        // if(e != null){
        //   e.scrollIntoView({behavior:"smooth",block:"end"})
        // }

    })
    .catch(function (error) {
        console.log(error);
    });
  };

}

export function loadMessage(message) {

  return (dispatch) => {


    dispatch(showGlobalSpinner());

    if(message) {

      let config = {
          method: 'get',
          url: `member/message/${message.SystemMessageID}`
      };
      
      resourceApi(config) 
      .then(function (response) {

        if(message.NewMessage){
          dispatch(clearTheDot(message.SystemMessageID));

          dispatch(decrementBadge());

        }
        
        dispatch(updateGlobalNewMessageCount())
        dispatch(showMessage(response.data));
        dispatch(loadMessageReplies(message.SystemMessageID));

        dispatch(hideGlobalSpinner());

      })
      .catch(function (error) {
          console.log(error);
          //self.setState({ fetching: false});
          dispatch(hideGlobalSpinner());
      });
      // .finally(function(){
      //   dispatch(hideGlobalSpinner());
      // });
    }
  }
  
}

function loadMessageReplies(id) {
  
  return (dispatch) => {

    let config = {
        method: 'get',
        url: `member/message/${id}/replies`
    };

    resourceApi(config) 
    .then(function (response) {
        dispatch(receiveMessageReplies(response.data));

        var element = document.getElementById("endOfChat");
        if(element) {
          //uses smoothscrolling-polyfill plugin, maths out to just above the chat input once user sends message and keyboard collapses.
          if(window.device && window.device.platform.toLowerCase() === 'ios'){
            // window.scrollTo({behavior:"smooth", top:(element.offsetTop - window.innerHeight)});
            window.scrollTo(0,(element.offsetTop - window.innerHeight));
          }
          else {       
            element.scrollIntoView({behavior:"smooth", block:"end"});
          }
        }


        // let e = document.getElementById("endOfChat");
        // if(e != null){
        //   e.scrollIntoView({behavior:"smooth",block:"end"})
        // }
    })
    .catch(function (error) {
        console.log(error);
    });
  }
}




export function deleteMessage(messageId) {
      
      return (dispatch) => {
        
        let config = {
            method: 'get',
            url: `member/message/${messageId}/delete`
        };

        resourceApi(config, dispatch)
        .then(function (response) {
            browserHistory.goBack();
            dispatch(deleteMessageFromRedux(messageId));
        })
        .catch(function (error) {
            console.log(error);
        });
      }
  }


//BOOBOO


export function changeToAbsolute() {
  return (dispatch, getState) => {

    var header = document.getElementById("dasHeader");
    if(header) {
      header.style.position = "absolute";
      header.style.top = "0px";
    }

    // on ios this setTieout allows the keyboard to show before repositioning the messageInput div relatively.
    setTimeout(function(){ 

      //window.alert('1.1.1');


      // var elTextBox1 = document.getElementById("divNext");
          
      // if(elTextBox1) {


      //   var elFaker  = document.getElementById("divFaker");
      //   //elFaker.style.display = "block";
      //     if(window.scrollY > 800){
      //       //elTextBox1.style.padding = "0 0 570px 0";
      //       //elTextBox1.style.padding = "0 0 50px 0";
      //       //elFaker.style.display = "block";
      //     }
      //     else{
      //       //elTextBox1.style.padding = "0 0 270px 0";
      //     }

          
        
      // }

   
     // var initialHeight = getState().thisApp.messaging.minHeight;

      var result = (window.screen.height - window.innerHeight);

      //dispatch(setMinHeight(window.innerHeight));

      // this needs to be done first.
      // dispatch(setDimensions(
      //   {
      //     clientHeight: document.documentElement.clientHeight,
      //     innerHeight:window.innerHeight,
      //     outerHeight: window.outerHeight,
      //     screenHeight: window.screen.height
      //   }
      // ));
        //document.documentElement.clientHeight));

      // var endOfChat = document.getElementById("endOfChat");
      //   if(endOfChat) {
      //     endOfChat.style.height = 100000;
      //   }

        document.body.style.height = window.innerHeight + 350;
        var endOfChat = document.getElementById("endOfChat");
        if(endOfChat) {
          endOfChat.style.height = 5;//result;
          //endOfChat.scrollIntoView();
        }

      var elTextBox = document.getElementById("messageInput");
          
          if(elTextBox) {
            
             //elTextBox.style.position = "fixed";
             //elTextBox.style.bottom = result; // pixels/height of the control;//0; //((window.innerHeight / 2)- 74);
             //elTextBox.style.bottom = result
             elTextBox.scrollIntoView();
            }
        
        
        

        //dispatch(disableScroll());

    }, 350);
  }
}



export function changeToFixed() {
  return (dispatch) => {
     
    // dispatch(enableScroll());

    var elTextBox = document.getElementById("messageInput");
    if(elTextBox) {
      elTextBox.style.position = "fixed";
      elTextBox.style.bottom = 0;
    }

    

    
    // var elTextBox = document.getElementById("divNext"); //messageParent
          
    // if(elTextBox) {
    //   //elTextBox.style.position = "relative";
    //   elTextBox.style.padding = 0;
      
    // }
  }
}


function preventDefault(e){
  e.preventDefault();
}

function disableScroll(){
  return (dispatch) => {
    document.body.addEventListener('touchmove', preventDefault, { passive: false });
  }
}
export function enableScroll(){
return (dispatch) => {
  document.body.removeEventListener('touchmove', preventDefault, { passive: false });
}
}

export function focusText() {
  return (dispatch) => {
    dispatch(changeToAbsolute());
  }
}



// WEBPACK FOOTER //
// ./src/actions/messageActions.js